import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiStar, FiPlus, FiHeart } from 'react-icons/fi';
import { useCart } from '../../context/CartContext';

export default function ProductCard({ product }) {
  const { addToCart } = useCart();

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="group relative flex flex-col h-full bg-white rounded-4xl p-3 sm:p-5 transition-all duration-500 hover:shadow-premium focus-within:ring-2 focus-within:ring-bloom-coral focus-within:ring-offset-2 outline-none"
    >
      {product.tag && (
        <div className="absolute top-8 left-8 z-20 bg-white/90 backdrop-blur-md px-4 py-1.5 rounded-full shadow-sm">
          <span className="text-[10px] font-black uppercase tracking-widest text-bloom-charcoal">
            {product.tag}
          </span>
        </div>
      )}

      <button 
        className="absolute top-8 right-8 z-20 w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity shadow-sm text-gray-400 hover:text-bloom-coral"
        aria-label={`Add ${product.name} to wishlist`}
      >
        <SafeIcon icon={FiHeart} />
      </button>
      
      <div className="relative aspect-[4/5] rounded-3xl overflow-hidden mb-6 bg-bloom-sand">
        <img 
          src={product.image} 
          alt={product.name} 
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-x-4 bottom-4 translate-y-12 group-hover:translate-y-0 group-focus-within:translate-y-0 transition-transform duration-300">
          <button 
            onClick={() => addToCart(product)}
            className="w-full bg-white py-3 rounded-2xl font-bold text-sm shadow-xl flex items-center justify-center gap-2 hover:bg-bloom-charcoal hover:text-white transition-colors"
          >
            <SafeIcon icon={FiPlus} /> Quick Add
          </button>
        </div>
      </div>
      
      <div className="flex flex-col flex-grow px-2">
        <div className="flex items-center gap-1.5 mb-2">
          <div className="flex text-bloom-yellow text-xs">
            <SafeIcon icon={FiStar} className="fill-current" />
          </div>
          <span className="text-[11px] font-bold text-gray-500">{product.rating} ({product.reviews})</span>
        </div>
        
        <h3 className="font-heading font-bold text-xl text-bloom-charcoal mb-2 line-clamp-1 group-hover:text-bloom-coral transition-colors">
          {product.name}
        </h3>
        <p className="text-sm text-gray-500 mb-4 line-clamp-2 leading-relaxed">
          {product.description}
        </p>
        
        <div className="mt-auto pt-4 flex items-center justify-between border-t border-gray-50">
          <span className="font-heading font-bold text-2xl">${product.price.toFixed(2)}</span>
          <span className="text-[10px] font-bold text-bloom-mint uppercase tracking-wider">Free Shipping</span>
        </div>
      </div>
    </motion.div>
  );
}